// components/common/messenger-sidebar.jsx
// ─────────────────────────────────────────────────────────
// Sidebar / Drawer สำหรับ Messenger
// ใช้ใน messenger-myjob.jsx และหน้าอื่นๆ ของ Messenger
// ─────────────────────────────────────────────────────────

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GetDataFullName, GetDataEmail } from '../utils/data-storage';

// ─── Menu Items ───────────────────────────────────────────
const MENU_ITEMS = [
  {
      key: 'profile',
      label: 'บัญชีของฉัน',
      path: '/messenger/profile',
      icon: <i className="mdi mdi-face-man-outline" />,
  },
  {
      key: 'myjob',
      label: 'งานของฉัน',
      path: '/messenger/myjob',
      icon: <i className="mdi mdi-moped" />,
  },
//   {
//       key: 'history',
//       label: 'ประวัติส่งงาน',
//       path: '/messenger/history',
//       icon: <i className="mdi mdi-road" />,
//   },
];

// ─── Component ────────────────────────────────────────────
const MessengerSidebar = () => {
    const navigate  = useNavigate();
    const location  = useLocation();
    const [open, setOpen] = useState(false);

    const fullName = GetDataFullName?.() || 'Messenger';
    const email    = GetDataEmail?.() || '';

    const onClickMenu = (path) => {
        setOpen(false);
        navigate(path);
    };

    const onClickLogout = () => {
        localStorage.clear();
        navigate('/login', { replace: true });
    };

    return (
        <>
            {/* ── Hamburger Button ── */}
            <button
                className="mmj-menu-btn"
                aria-label="เปิดเมนู"
                onClick={() => setOpen(true)}
            >
                <span /><span /><span />
            </button>

            {/* ── Overlay ── */}
            {open && (
                <div
                    className="msb-overlay"
                    onClick={() => setOpen(false)}
                />
            )}

            {/* ── Drawer ── */}
            <div className={`msb-drawer ${open ? 'msb-drawer--open' : ''}`}>

                {/* Header */}
                <div className="msb-header">
                    <button
                        className="msb-close-btn"
                        onClick={() => setOpen(false)}
                        aria-label="ปิดเมนู"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="#1E293B" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                    <span className="msb-header-title">เมนู</span>
                </div>

                {/* Menu Items */}
                <nav className="msb-nav">
                    {MENU_ITEMS.map((item) => (
                        <button
                            key={item.key}
                            className={`msb-item ${location.pathname === item.path ? 'msb-item--active' : ''}`}
                            onClick={() => onClickMenu(item.path)}
                        >
                            <span className="msb-item-icon">{item.icon}</span>
                            <span className="msb-item-label">{item.label}</span>
                        </button>
                    ))}
                </nav>

                {/* Logout */}
                <div className="msb-footer">
                <button className="msb-logout" onClick={onClickLogout}>
                    <i className="mdi mdi-logout" />
                    <span>ออกจากระบบ</span>
                </button>
                </div>
            </div>
        </>
    );
};

export default MessengerSidebar;